import React, { Component } from 'react';
import { DatePicker, Button } from 'antd';
import SearchSelect from '../../common/SearchSelect';
import API_URL from '../../../common/url';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        loading: false,
        searchParams: {
            startDate: null,
            endDate: null,
        },
        userOptions: [],
    }

    componentDidMount() {
        this.setQuarter();
        this.search();
    }

    setQuarter = (date) => {
        const dateObj = date ? moment(date) : moment();
        const year = dateObj.year();
        const quarter = dateObj.quarter();
        let offset = 0;
        // 每季度末26号之前默认显示上一季度评分，等26号后显示当前季度评分
        if (!date) {
            const scoreDate = moment().set({ year, month: 3 * quarter - 1, date: 26 });
            offset = moment().valueOf() < scoreDate.valueOf() ? 1 : 0;
        }
        // 是否是一季度， 是（年份减一，季度设为四季度）
        const isFirstQuarter = offset && quarter == 1;
        const startMonth = 1 + 3 * ((isFirstQuarter ? 3 : quarter - 1 - offset));
        const endMonth = 3 * ((isFirstQuarter ? 4 : quarter - offset));
        const { searchParams } = this.state;
        searchParams.startDate = `${year - (isFirstQuarter ? 1 : 0)}-${startMonth < 10 ? `0${startMonth}` : startMonth}`;
        searchParams.endDate = `${year- (isFirstQuarter ? 1 : 0)}-${endMonth < 10 ? `0${endMonth}` : endMonth}`;
        this.setState({ searchParams });
    }

    //角色
    userSelectChanged = value => {
        const { searchParams } = this.state;
        if (value) {
            searchParams.userId = value.key;
        } else {
            searchParams.userId = '';
        }
        this.setState({ searchParams });
    }

    parseUserData = (res, value) => {
        if ((res.data || res.datas) ) {
            const sourceData = res.data ? res.data.crcList: res.datas;
            const data = sourceData.map(item => ({
                text: `${item.userCompellation}[${item.employeeCode}]`,
                value: item.userId,
            }));
            this.setState({ userOptions: data });
        } else {
            this.setState({ userOptions: [] });
        }
    }
    
    onStartChange = (data, dateString) => {
        this.setQuarter(dateString);
    }

    search = () => {
        const { searchParams } =  this.state;
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    render() { 
        const { userOptions, searchParams: { startDate, endDate } } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item month-range-picker">
                    <label className="ui-label">考核时间</label>
                    <MonthPicker
                        className="begin"
                        format={monthFormat}
                        value={startDate ? moment(startDate) : null}
                        allowClear={true}
                        placeholder="请选择季度"
                        onChange={this.onStartChange}
                    />
                    <MonthPicker
                        className="end"
                        format={monthFormat}
                        value={endDate ? moment(endDate) : null}
                        allowClear={true}
                        placeholder="请选择季度"
                        onChange={this.onStartChange}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">CRC</label>
                    <SearchSelect 
                        style={{width:160}}
                        url = {API_URL.team.userlist}
                        searchKey = 'keyword'
                        sourceData={ userOptions}
                        parserData={ this.parseUserData }
                        watchValue={this.userSelectChanged}
                        handleSelect = { this.userSelectChanged }
                        placeholder='输入名字或工号自动检索'
                        allowClear={true}
                        className='w-160-select'
                    />
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/sumTotal/crcQuarterScore/Filter.js